import {getUserFirstName} from "../../user/utils/get_user_first_name";

export const getSmsLoginAccountMismatchMessage = (name?: string | null) => {
    const firstName = getUserFirstName(name);
    const messageWithoutName =
        "Masz już u nas konto, ale wpisany numer telefonu jest inny niż podawany wcześniej. Popraw numer, aby kontynuować, lub podaj inny adres e-mail, by założyć nowe konto.";
    const messageWithName =
        "masz już u nas konto, ale wpisany numer telefonu jest inny niż podawany wcześniej. Popraw numer, aby kontynuować, lub podaj inny adres e-mail, by założyć nowe konto.";

    return firstName ? `${firstName}, ${messageWithName}` : messageWithoutName;
};
import {getUserFirstName} from "../../user/utils/get_user_first_name";

export const getSmsLoginAccountMismatchMessage = (name?: string | null) => {
    const firstName = getUserFirstName(name);
    const messageWithoutName =
        "Masz już u nas konto, ale wpisany numer telefonu jest inny niż podawany wcześniej. Popraw numer, aby kontynuować, lub podaj inny adres e-mail, by założyć nowe konto.";
    const messageWithName =
        "masz już u nas konto, ale wpisany numer telefonu jest inny niż podawany wcześniej. Popraw numer, aby kontynuować, lub podaj inny adres e-mail, by założyć nowe konto.";

    return firstName ? `${firstName}, ${messageWithName}` : messageWithoutName;
};
